import React from 'react';
import { Phone, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../mock/mockData';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-slate-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold">
                {businessInfo.serviceArea}
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Transform Your Cluttered{' '}
              <span className="text-blue-600">Garage</span> Into An Organized Space
            </h1>
            
            <p className="text-xl text-slate-600 leading-relaxed">
              Professional garage cleanout and organization services in London, Ontario. 
              From basic cleanouts to complete transformations, we help you reclaim your space.
            </p>

            {/* Benefits */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <span className="text-slate-700">Same-week service available</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <span className="text-slate-700">Free on-site estimates</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <span className="text-slate-700">Eco-friendly disposal & donation</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={() => scrollToSection('contact')}
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
              >
                Get Free Quote
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button
                onClick={() => scrollToSection('packages')}
                size="lg"
                variant="outline"
                className="border-2 border-slate-300 hover:border-blue-600 hover:text-blue-600 text-lg px-8 py-6 transition-all"
              >
                View Packages
              </Button>
            </div>

            {/* Contact Info */}
            <div className="flex items-center space-x-3 pt-4">
              <Phone className="h-5 w-5 text-blue-600" />
              <div>
                <p className="text-sm text-slate-500">Call us today</p>
                <a
                  href={`tel:${businessInfo.phoneRaw}`}
                  className="text-2xl font-bold text-slate-900 hover:text-blue-600 transition-colors"
                >
                  {businessInfo.phone}
                </a>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/qs7rhek2_IMG_1354.JPG"
                alt="Organized garage"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="bg-blue-100 rounded-full p-3">
                  <CheckCircle className="h-8 w-8 text-blue-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">500+</p>
                  <p className="text-sm text-slate-600">Garages Transformed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
